import React, { useState } from 'react';
import { AnalyticsController } from '../../layout/Analytics';
import './VOBWhatMattersMost.scss';

export const VOBWhatMattersMost = ({ node }) => {
    const [buttonVisible, setButtonVisible] = useState(0);

    return (
        <section className="vob-wmm">
            <div className="kite-container">
                <h2>{node.field_title}</h2>
                <ul>
                    <li
                        className={buttonVisible === 0 ? `active` : undefined}
                        aria-details="wmm-1"
                    >
                        <button
                            onClick={() => {
                                setButtonVisible(0);
                                AnalyticsController.track({
                                    event: `broadband matters most ${node.field_card_title} click`,
                                });
                            }}
                            role="presentation"
                        ></button>
                        <figure role="presentation">
                            <svg
                                viewBox="0 0 48 73"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M39.5625 0.1875H8.4375C4.14198 0.192189 0.660939 3.67323 0.65625 7.96875V65.0312C0.660939 69.3268 4.14198 72.8078 8.4375 72.8125H39.5625C43.858 72.8078 47.3391 69.3268 47.3438 65.0312V7.96875C47.3391 3.67323 43.858 0.192189 39.5625 0.1875ZM8.4375 5.375H39.5625C40.9944 5.37643 42.1548 6.53685 42.1562 7.96875V10.5625H5.84375V7.96875C5.84518 6.53685 7.0056 5.37643 8.4375 5.375ZM42.1562 15.75V57.25H5.84375V15.75H42.1562ZM39.5625 67.625H8.4375C7.0056 67.6236 5.84518 66.4631 5.84375 65.0312V62.4375H42.1562V65.0312C42.1548 66.4631 40.9944 67.6236 39.5625 67.625Z"
                                    fill="currentColor"
                                ></path>
                            </svg>
                        </figure>
                        <h3>{node.field_card_title}</h3>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: node.field_item_1_text?.value,
                            }}
                        ></p>
                    </li>

                    <li
                        className={buttonVisible === 1 ? `active` : undefined}
                        aria-details="wmm-2"
                    >
                        <button
                            onClick={() => {
                                setButtonVisible(1);
                                AnalyticsController.track({
                                    event: `broadband matters most ${node.field_card_title_2} click`,
                                });
                            }}
                            role="presentation"
                        ></button>
                        <figure role="presentation">
                            <svg
                                viewBox="0 0 74 73"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M37.001 0C57.0558 0 73.3135 16.2577 73.3135 36.3125V38.9062H73.1817C71.8419 57.9006 56.0421 72.6251 37.0006 72.6251C17.959 72.6251 2.15931 57.9006 0.819487 38.9062H0.688477V36.3125C0.688477 16.2577 16.9461 0 37.001 0ZM26.9939 38.9062H6.00707C7.3661 55.0201 20.8299 67.4141 37.001 67.4375C53.1718 67.414 66.6354 55.0199 67.9943 38.9062H47.0074C45.8439 43.4833 41.7233 46.6875 37.0007 46.6875C32.278 46.6875 28.1574 43.4833 26.9939 38.9062ZM44.7821 54.4688V59.6563H29.2196V54.4688H44.7821ZM37.001 31.125C34.1375 31.1287 31.8172 33.4491 31.8135 36.3125C31.8135 39.1775 34.136 41.5 37.001 41.5C39.866 41.5 42.1885 39.1775 42.1885 36.3125C42.1885 33.4475 39.866 31.125 37.001 31.125ZM37.001 5.1875C20.824 5.20722 7.35106 17.5998 5.98235 33.7188H11.1949C12.5261 20.4652 23.6806 10.3749 37.0008 10.3749C50.321 10.3749 61.4756 20.4652 62.8068 33.7188H68.0196C66.6509 17.5998 53.1779 5.2072 37.001 5.1875ZM53.3715 23.6094L45.9062 31.075C46.3951 31.9004 46.7658 32.7903 47.0074 33.7188H57.5705C57.1072 30.0322 55.6564 26.5393 53.3715 23.6094ZM49.7039 19.9417C43.8276 15.3568 35.94 14.2855 29.0537 17.1369C22.1674 19.9882 17.3459 26.3219 16.4308 33.7188H26.994C27.7795 30.5605 30.0172 27.9624 33.0242 26.7175C36.0312 25.4725 39.4505 25.7285 42.2386 27.4072L49.7039 19.9417Z"
                                    fill="currentColor"
                                ></path>
                            </svg>
                        </figure>
                        <h3>{node.field_card_title_2}</h3>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: node.field_item_2_text?.value,
                            }}
                        ></p>
                    </li>

                    <li
                        className={buttonVisible === 2 ? `active` : undefined}
                        aria-details="wmm-3"
                    >
                        <button
                            onClick={() => {
                                setButtonVisible(2);
                                AnalyticsController.track({
                                    event: `broadband matters most ${node.field_card_title_3} click`,
                                });
                            }}
                            role="presentation"
                        ></button>
                        <figure role="presentation">
                            <svg
                                viewBox="0 0 64 73"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M32.001 0.186279C42.0284 0.186279 50.1572 8.31511 50.1572 18.3425V26.1238H63.126V65.03C63.1213 69.3256 59.6403 72.8066 55.3447 72.8113H8.65723C4.3617 72.8066 0.880665 69.3256 0.875977 65.03V26.1238H13.8447V18.3425C13.8447 8.31511 21.9736 0.186279 32.001 0.186279ZM57.9385 31.3113H6.06348V65.03C6.06444 66.4621 7.22513 67.6228 8.65723 67.6238H55.3447C56.7768 67.6228 57.9375 66.4621 57.9385 65.03V31.3113ZM34.5946 39.0926V59.8426H29.4071V39.0926H34.5946ZM32.001 5.37378C24.8385 5.37378 19.0322 11.1801 19.0322 18.3425V26.1238H44.9697V18.3425C44.9697 11.1801 39.1634 5.37378 32.001 5.37378Z"
                                    fill="currentColor"
                                ></path>
                            </svg>
                        </figure>
                        <h3>{node.field_card_title_3}</h3>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: node.field_item_3_text?.value,
                            }}
                        ></p>
                    </li>
                </ul>
                <p
                    dangerouslySetInnerHTML={{
                        __html: node.field_item_1_text?.value,
                    }}
                    className={buttonVisible === 0 ? `visible` : undefined}
                    role="presentation"
                ></p>
                <p
                    role="presentation"
                    dangerouslySetInnerHTML={{
                        __html: node.field_item_2_text?.value,
                    }}
                    className={buttonVisible === 1 ? `visible` : undefined}
                ></p>
                <p
                    role="presentation"
                    dangerouslySetInnerHTML={{
                        __html: node.field_item_3_text?.value,
                    }}
                    className={buttonVisible === 2 ? `visible` : undefined}
                ></p>
            </div>
        </section>
    );
};
